import { useState } from "react";
import HealthLogo from "../../../assets/img/healthlogo.svg";
import { organisationNavMenu } from "../../../data/utils";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { BaseButton } from "../../base";
import {
  emptyLocalStorage,
  emptySessionStorage,
} from "../../../utils/browserStorage";
import { resetNewBookingData } from "../../../store/slices/organisation";
import { useAppDispatch } from "../../../store";
const OrganisationSideBar = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const styles = {
    menuItems: `flex gap-3 py-3 transition text-lg mb-2 rounded-md items-center menuItem_text cursor-pointer `,
  };

  const dispatch = useAppDispatch();

  const Logout = () => {
    setIsProcessing(true);
    emptySessionStorage();
    emptyLocalStorage();
    dispatch(resetNewBookingData());
    navigate("/login");
    setIsProcessing(false);
  };

  return (
    <aside className="hidden lg:block lg:fixed left-0  h-full w-1/5 bg-[#F4F6FC] px-5 py-8 transition">
      <Link to={"/"}>
        <img src={HealthLogo} alt="logo" />
      </Link>
      <div className="mt-12 transition">
        <div className="flex flex-col w-full h-full transition gap-3">
          {organisationNavMenu
            .filter((res) => res.active === true)
            .map((nav, index) => {
              return (
                <div
                  key={index}
                  className={`${styles.menuItems} ${
                    !nav.active && "cursor-not-allowed opacity-50"
                  }`}
                >
                  <img src={nav.icon} alt="icon" />
                  <Link
                    to={nav.route}
                    className={`${
                      nav.route
                        ? //=== pathname
                          "text-[#0C4654]"
                        : "text-[#94A3B5]"
                    }`}
                  >
                    <span className=""> {nav.name}</span>
                  </Link>
                </div>
              );
            })}
        </div>
        <BaseButton
          text="Log out"
          type="submit"
          variant="neutral"
          styles="px-6 py-2 !text-red-500 !border-red-400  mt-28 font-bold border-2px"
          click={Logout}
          processing={isProcessing}
        />
      </div>
    </aside>
  );
};

export default OrganisationSideBar;
